import ApplicationsTab from "./ApplicationsTab";

export default ApplicationsTab;